(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog-post"]) return;
  try {
    
  function arrangeNutvilaRecipe(section) {
    const content = section.querySelector('.nutvila-recipe__legacy');
    if (!content || content.dataset.arranged === 'true') return;
    const ingredientPattern = /^(ingredientai|ingredients|zutaten|ingrédients)\s*:?$/i;
    const methodPattern = /^(gaminimas|method|instructions|zubereitung|préparation)\s*:?$/i;
    const directNodes = [...content.children];
    const ingredientHeading = directNodes.find((node) => /^H[2-4]$/.test(node.tagName) && ingredientPattern.test(node.textContent.trim()));
    const methodHeading = directNodes.find((node) => /^H[2-4]$/.test(node.tagName) && methodPattern.test(node.textContent.trim()));
    let ingredientList;
    let stepList;
    if (ingredientHeading && methodHeading) {
      const start = directNodes.indexOf(ingredientHeading);
      const middle = directNodes.indexOf(methodHeading);
      if (middle <= start) return;
      const nextHeading = directNodes.findIndex((node, index) => index > middle && /^H[1-6]$/.test(node.tagName));
      const end = nextHeading < 0 ? directNodes.length : nextHeading;
      const grid = document.createElement('div');
      grid.className = 'nutvila-recipe__content-grid';
      content.insertBefore(grid, ingredientHeading);
      for (const [from, to] of [[start, middle], [middle, end]]) {
        const panel = document.createElement('div');
        panel.className = 'nutvila-recipe__content-panel';
        for (let index = from; index < to; index++) panel.appendChild(directNodes[index]);
        grid.appendChild(panel);
      }
      grid.children[0].id = 'nutvila-recipe-card-ingredients';
      grid.children[1].id = 'nutvila-recipe-card-steps';
      ingredientList = grid.querySelector('.nutvila-recipe__content-panel ul');
      stepList = grid.querySelector('.nutvila-recipe__content-panel ol');
      const tip = [...content.children].find((node) => /^H[2-4]$/.test(node.tagName) && /^(patarimas|tip|tipp|astuce)\s*:?$/i.test(node.textContent.trim()));
      if (tip) {
        const tipPanel = document.createElement('aside');
        tipPanel.className = 'nutvila-recipe__tip-panel';
        content.insertBefore(tipPanel, tip);
        let node = tip;
        while (node && (node === tip || node.nodeType !== 1 || !/^H[1-6]$/.test(node.nodeName))) {
          const next = node.nextSibling;
          tipPanel.appendChild(node);
          node = next;
        }
      }
    } else {
      const paragraphs = [...content.querySelectorAll(':scope > p')];
      const boldLabel = (node) => (node.querySelector(':scope > b, :scope > strong')?.textContent || '').trim();
      const ingredientStart = paragraphs.findIndex((node) => ingredientPattern.test(boldLabel(node)));
      const methodStart = paragraphs.findIndex((node) => methodPattern.test(boldLabel(node)));
      if (ingredientStart < 0 || methodStart <= ingredientStart) return;
      const grid = document.createElement('div');
      grid.className = 'nutvila-recipe__content-grid';
      const ingredients = document.createElement('div');
      const method = document.createElement('div');
      ingredients.className = method.className = 'nutvila-recipe__content-panel';
      const heading = (text) => { const h = document.createElement('h2'); h.textContent = text; return h; };
      ingredients.appendChild(heading(section.dataset.ingredientsLabel));
      method.appendChild(heading(section.dataset.stepsLabel));
      ingredientList = document.createElement('ul');
      ingredients.appendChild(ingredientList);
      stepList = document.createElement('ol');
      method.appendChild(stepList);
      const ingredientNodes = paragraphs.slice(ingredientStart, methodStart);
      for (const paragraph of ingredientNodes) {
        const label = boldLabel(paragraph);
        if (label && !ingredientPattern.test(label)) {
          const subheading = document.createElement('h3');
          subheading.textContent = label;
          ingredients.appendChild(subheading);
          ingredientList = document.createElement('ul');
          ingredients.appendChild(ingredientList);
        } else if (!label) {
          const item = document.createElement('li');
          item.textContent = paragraph.textContent.replace(/^\s*[●•]\s*/, '').trim();
          if (item.textContent) ingredientList.appendChild(item);
        }
      }
      const methodNodes = paragraphs.slice(methodStart);
      for (const [index, paragraph] of methodNodes.entries()) {
        const item = document.createElement('li');
        if (index === 0) {
          const copy = paragraph.cloneNode(true);
          copy.querySelector(':scope > b, :scope > strong')?.remove();
          item.textContent = copy.textContent.trim();
        } else {
          item.textContent = paragraph.textContent.trim();
        }
        if (item.textContent) stepList.appendChild(item);
      }
      if (!ingredients.querySelector('li') || !stepList.querySelector('li')) return;
      content.insertBefore(grid, paragraphs[ingredientStart]);
      grid.append(ingredients, method);
      ingredients.id = 'nutvila-recipe-card-ingredients';
      method.id = 'nutvila-recipe-card-steps';
      for (const paragraph of [...ingredientNodes, ...methodNodes]) paragraph.remove();
    }
    content.dataset.arranged = 'true';
    const intro = [...content.children].find((node) => node.tagName === 'P');
    if (intro && intro === content.firstElementChild) intro.remove();
  }
  document.querySelectorAll('.nutvila-recipe').forEach(arrangeNutvilaRecipe);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.nutvila-recipe').forEach(arrangeNutvilaRecipe);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nutvila-recommendation-card')) {
    customElements.define('nutvila-recommendation-card', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) { this.observer?.observe(this); return; }
        this.initialized = true;
        this.button = this.querySelector('.nutvila-recommendation-add');
        if (!this.button) return;
        this.icon = this.button.innerHTML;
        this.status = this.querySelector('.nutvila-recommendation-status');
        this.addEventListener('click', (event) => {
          if (!event.target.closest('.nutvila-recommendation-add')) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          if (!this.button.disabled) this.addProduct();
        }, true);
        this.observer = new ResizeObserver(() => this.positionButton());
        this.observer.observe(this);
        requestAnimationFrame(() => this.positionButton());
      }
      disconnectedCallback() {
        this.observer?.disconnect();
      }
      positionButton() {
        const media = this.querySelector('.card-gallery, product-card .product-card__image, product-card img');
        if (!media) return;
        let mediaTop = 0;
        let element = media;
        while (element && element !== this) {
          mediaTop += element.offsetTop;
          element = element.offsetParent;
        }
        const inset = matchMedia('(max-width: 749px)').matches ? 8 : 12;
        this.style.setProperty('--nutvila-add-top', Math.max(inset, mediaTop + media.offsetHeight - this.button.offsetHeight - inset) + 'px');
      }
      async addProduct() {
        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');
        this.status.textContent = '';
        this.button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8" fill="none" stroke="currentColor" stroke-width="2" stroke-dasharray="36 15"><animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.7s" repeatCount="indefinite"/></circle></svg>';
        try {
          const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component')].map(el => el.dataset.sectionId).filter(Boolean))].slice(0, 5);
          const response = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(this.button.dataset.variantId), quantity: 1 }], sections: sectionIds, sections_url: location.pathname })
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message || 'Nepavyko pridėti produkto. Bandykite dar kartą.');
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: result, sourceId: 'nutvila-recommendations', data: { source: 'product-form-component', itemCount: 1, sections: result.sections || {} } }
          }));
          this.button.innerHTML = '<svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path d="m5 12 4 4L19 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          setTimeout(() => { this.button.innerHTML = this.icon; }, 1600);
        } catch (error) {
          this.button.innerHTML = this.icon;
          this.status.textContent = error.message;
        } finally {
          this.button.disabled = false;
          this.button.removeAttribute('aria-busy');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
